import type { ProjectTypeOption } from './enquiryConfig';
import { SelectableCard } from './SelectableCard';

interface Step3ProjectTypeProps {
    title: string;
    options: ProjectTypeOption[];
    value: string | null;
    onSelect: (title: string) => void;
}

export const Step3ProjectType = ({
    title,
    options,
    value,
    onSelect,
}: Step3ProjectTypeProps) => {
    return (
        <div className="flex flex-col gap-[1.375rem]">
            <h2 className="text-[1.3125rem] font-medium uppercase leading-[1.1] tracking-[-0.02em] text-[#161616]">
                {title}
            </h2>
            <ul className="flex flex-col gap-2">
                {options.map((option) => (
                    <li key={option.title}>
                        <SelectableCard
                            title={option.title}
                            subtitle={option.subtitle}
                            selected={value === option.title}
                            onClick={() => onSelect(option.title)}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};
